import { render, staticRenderFns } from "./qanda.vue?vue&type=template&id=609d66a9&"
import script from "./qanda.vue?vue&type=script&lang=js&"
export * from "./qanda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports